import { timeAndLoadTypes } from "@/api/femsAPI";
import { CalendarDate } from "@/components/Calendar";
import { useQuery } from "@tanstack/react-query";
import { ProcessQueryEnabeld } from "./useProcessedQuery";

export const useYearlyQuery = (
  {
    yearlyTrioEnabled,
    yearlyTrioLoadTypeEnabled,
    yearlyPairEnabled,
    yearLoadTypeEnabled,
    yearSingleEnabled,
    usageAgaunstEnabled,
  }: ProcessQueryEnabeld,
  selectedDate?: CalendarDate,
  equipment?: string | null,
) => {
  const today = (selectedDate && selectedDate[0]) ?? new Date();
  // const year = today.getUTCFullYear();
  // const month = today.getUTCMonth() + 1; // getUTCMonth()는 0부터 시작하므로 1을 더합니다.
  // const day = today.getUTCDate();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  const start = `${year}-${String(month).padStart(2, "0")}-${String(day - 1).padStart(
    2,
    "0",
  )}T15:00:00.000Z`;
  const end = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
    2,
    "0",
  )}T15:00:00.000Z`;

  const { data: yearlyTrio, isLoading: yearlyTrioLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "YEARLY_TRIO",
      date: `${year}-${month}-${day}`,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: yearlyTrioEnabled,
  });

  const { data: yearlyTrioLoadType, isLoading: yearlyTrioLoadTypeLoading } = useQuery({
    ...timeAndLoadTypes.getPeriodLoadType({
      start: `${year}-01-01T00:00:00.000Z`,
      end: `${year}-12-31T23:59:59.999Z`,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: yearlyTrioLoadTypeEnabled,
  });

  const { data: yearlyPair, isLoading: yearlyPairLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "YEARLY_PAIR",
      date: year.toString(),
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: yearlyPairEnabled,
  });

  const { data: yearLoadType, isLoading: yearLoadTypeLoading } = useQuery({
    ...timeAndLoadTypes.getTimeMonthlyLoadType({
      year: year,
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: yearLoadTypeEnabled,
  });

  const { data: yearSingle, isLoading: yearSingleLoading } = useQuery({
    ...timeAndLoadTypes.getPeriod({
      type: "YEARLY_SINGLE",
      date: year.toString(),
      ...(equipment ? { equipmentCode: equipment } : {}),
    }),
    enabled: yearSingleEnabled,
  });

  const { data: usageAgaunst, isLoading: usageAgaunstLoading } = useQuery({
    ...timeAndLoadTypes.usageAgaunstTarget({
      year: year,
    }),
    enabled: usageAgaunstEnabled,
  });

  return {
    yearlyTrio,
    yearlyTrioLoadType,
    yearlyPair,
    yearLoadType,
    yearSingle,
    usageAgaunst,

    yearlyTrioLoading,
    yearlyTrioLoadTypeLoading,
    yearlyPairLoading,
    yearLoadTypeLoading,
    yearSingleLoading,
    usageAgaunstLoading,
  };
};
